/* eslint-disable import/prefer-default-export */
export const DEFAULT_PAGE_SIZE = 24;
// DNPU key
export const PRIVATE_PDF_KEY = '67n5e554v7s5x2dajpu65x85216';
// PNT QR code key
export const QR_CODE_KEY = 'DDBD6532-78E8-4A45-8D10-4F89C70943BF';
export const PDF_CRYTO_PADDING = 5;
